import { render, staticRenderFns } from "./ProductsLoading.vue?vue&type=template&id=48946ebb&"
import script from "./ProductsLoading.vue?vue&type=script&lang=js&"
export * from "./ProductsLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports